/** Session flag: blocks #auth= handoff replay and post-sign-out auto-redirect (both apps). */
export const AUTH_REVOKED_SESSION_KEY = "career_scoops_auth_revoked";


const HANDOFF_CONSUMED_PREFIX = "career_scoops_handoff_used_";

export function markAuthRevoked() {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(AUTH_REVOKED_SESSION_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function clearAuthRevoked() {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(AUTH_REVOKED_SESSION_KEY);
  } catch {
    /* ignore */
  }
}

export function isAuthRevoked() {
  if (typeof window === "undefined") return false;
  try {
    return sessionStorage.getItem(AUTH_REVOKED_SESSION_KEY) === "1";
  } catch {
    return false;
  }
}

export function markAuthHandoffConsumed(encodedPayload) {
  if (typeof window === "undefined") return;
  try {
    const id = encodedPayload.slice(0, 96);
    sessionStorage.setItem(`${HANDOFF_CONSUMED_PREFIX}${id}`, "1");
  } catch {
    /* ignore */
  }
}

export function isAuthHandoffConsumed(encodedPayload) {
  if (typeof window === "undefined") return false;
  try {
    const id = encodedPayload.slice(0, 96);
    return sessionStorage.getItem(`${HANDOFF_CONSUMED_PREFIX}${id}`) === "1";
  } catch {
    return false;
  }
}

export function stripAuthHashFromUrl() {
  if (typeof window === "undefined" || !window.location.hash.includes("auth=")) return;
  const { pathname, search } = window.location;
  window.history.replaceState(null, "", `${pathname}${search}`);
}
